import { styled } from '@mui/material/styles';

import { getWidthFromHeight } from 'lib/helpers/imageSizer';
import { ExclusivePartnerBadge } from './ExclusivePartnerEntry';

import {
  IExclusiveBadge,
  IExclusiveBadgeFields,
} from 'types/generated/contentful';
import { AssetDetails } from 'contentful';

const IMAGE_HEIGHT_RAW = 35;

const Wrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: '0',
  width: '100%',
  alignItems: 'center',
  justifyContent: 'center',

  [theme.breakpoints.up('md')]: {
    alignItems: 'left',
    justifyContent: 'left',
    width: 'fit-content',
    flexDirection: 'row',
    padding: '8px 12px',
  },
}));

const BadgeWrapper = styled('div')`
  margin-right: 5px;
  display: flex;
  width: 100%;
`;

interface ExclusivePartnersProps {
  exclusivePartners: IExclusiveBadge[] | undefined;
}
export const ExclusivePartnerBadges = (props: ExclusivePartnersProps) => {
  const { exclusivePartners } = props;

  if (!exclusivePartners) {
    return null;
  }

  return (
    <Wrapper>
      {exclusivePartners.map((entry) => {
        const { image, title, name } = entry.fields as IExclusiveBadgeFields;
        const url = image.fields.file?.url;
        const imageDetails = image.fields.file?.details as AssetDetails;

        const originalWidth = imageDetails.image?.width || IMAGE_HEIGHT_RAW;
        const originalHeight = imageDetails.image?.height || IMAGE_HEIGHT_RAW;
        const scaledWidth = getWidthFromHeight(
          originalHeight,
          originalWidth,
          IMAGE_HEIGHT_RAW,
        );

        return (
          <BadgeWrapper key={entry.sys.id}>
            <ExclusivePartnerBadge
              name={name}
              title={title}
              url={url}
              height={IMAGE_HEIGHT_RAW}
              width={scaledWidth}
            />
          </BadgeWrapper>
        );
      })}
    </Wrapper>
  );
};
